import { useLocation } from 'react-router-dom';
import { router } from '../router';

export function navigate(path: string | number) {
  if (typeof path === 'number') {
    router.navigate(path);
  } else {
    router.navigate(path);
  }
}

/**
 * usePath hook that stays in sync with React Router's internal state.
 * Prefers useLocation() when available, falls back to window.location.
 */
export function usePath() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();
    return location.pathname;
  } catch (err) {
    // Fallback if called outside of a Router context (rare but possible in initialization)
    return window.location.pathname;
  }
}
